import { useMemo } from 'react'

import { useModals, useNumericParams, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateOrEditCampaignQuoteTemplateModal from '@modals/CreateOrEditCampaignQuoteTemplateModal'
import DownloadQuoteTemplateModal from '@modals/DownloadQuoteTemplateModal'

import PageContent from './components/PageContent'

const defaultState = {
  showCreateOrEditCampaignQuoteTemplateModal: false,
  showDownloadQuoteTemplateModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    CreateOrEditCampaignQuoteTemplateModal: {
      closeModal: () => setState({ showCreateOrEditCampaignQuoteTemplateModal: false }),
      updateCampaignQuoteTemplate: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
    DownloadQuoteTemplateModal: {
      closeModal: () => setState({ showDownloadQuoteTemplateModal: false }),
    },
  }

  return componentCallbacks[component] || {}
}

const Settings = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showCreateOrEditCampaignQuoteTemplateModal,
    showDownloadQuoteTemplateModal,
  } = state

  const { campaignQuoteTemplateId } = useNumericParams()

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      showCreateOrEditCampaignQuoteTemplateModal: (payload: object) => {
        setModalData('CreateOrEditCampaignQuoteTemplateModal', payload)
        setState({ showCreateOrEditCampaignQuoteTemplateModal: true })
      },
      showDownloadQuoteTemplateModal: (payload: object) => {
        setModalData('DownloadQuoteTemplateModal', payload)
        setState({ showDownloadQuoteTemplateModal: true })
      },
      updateCampaignQuoteTemplate: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent campaignQuoteTemplateId={campaignQuoteTemplateId} />

        <CreateOrEditCampaignQuoteTemplateModal
          // @ts-expect-error TS2741
          callbacks={callbacks('CreateOrEditCampaignQuoteTemplateModal', setState)}
          showModal={showCreateOrEditCampaignQuoteTemplateModal}
        />

        <DownloadQuoteTemplateModal
          callbacks={callbacks('DownloadQuoteTemplateModal', setState)}
          showModal={showDownloadQuoteTemplateModal}
        />

      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default Settings
